import trackCartDeleted from '@conversion/tracking/actions/trackCartDeleted';
import { CLEAR_ORDER_FLOW } from '../actionTypes';

const clearOrderFlow = () => dispatch => {
  dispatch(trackCartDeleted());
  dispatch({ type: CLEAR_ORDER_FLOW });
};

export default clearOrderFlow;
